module.exports = __webpack_public_path__ + "media/audios/kid/lesson_9/audio60-c85362ad2ffbbd90e85ab237475abfd4.m4a";